/* ============================================================
   custom-promo-tabs.js
   Custom Promo Tab System
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Helpers
     ---------------------------------------------------------- */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.cptMoneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function t(key, replacements) {
    const translations = window.cptTranslations || {};
    let str = translations[key] || key;
    if (replacements) {
      Object.keys(replacements).forEach(function (k) {
        var val = replacements[k];
        str = str.split('%' + k + '%').join(val);
        str = str.split('[' + k + ']').join(val);
        str = str.split('{{ ' + k + ' }}').join(val);
        if (k === 'amount') {
          str = str.split('%montant%').join(val);
          str = str.split('[montant]').join(val);
          str = str.split('{{ montant }}').join(val);
        } else if (k === 'price') {
          str = str.split('%prix%').join(val);
          str = str.split('[prix]').join(val);
          str = str.split('{{ prix }}').join(val);
        } else if (k === 'buy') {
          str = str.split('%achat%').join(val);
          str = str.split('[achat]').join(val);
          str = str.split('{{ achat }}').join(val);
        }
      });
    }
    return str;
  }

  function normalizeDiscountType(discountType) {
    if (discountType === 'bundle_price') return 'fixed_price';
    if (discountType === 'fixed') return 'fixed_amount';
    if (discountType === 'amount_off') return 'fixed_amount';
    if (discountType === 'dollar_off') return 'fixed_amount';
    if (discountType === 'price_off') return 'fixed_amount';
    return discountType || '';
  }

  function getBundleRefs(block) {
    if (block._cptBundleRefs) return block._cptBundleRefs;

    var items = Array.prototype.slice.call(block.querySelectorAll('.cpt-product-grid-item'));
    items.forEach(function (item) {
      if (!item.dataset.image) {
        var img = item.querySelector('img');
        item.dataset.image = (img && (img.currentSrc || img.getAttribute('src'))) || '';
      }
    });

    block._cptBundleRefs = {
      items: items,
      selectedWrap: block.querySelector('.cpt-selected-items'),
      summaryText: block.querySelector('.cpt-bundle-summary-text'),
      pricingWrap: block.querySelector('.cpt-bundle-pricing'),
      oldEl: block.querySelector('.cpt-bundle-price-old'),
      newEl: block.querySelector('.cpt-bundle-price-new'),
      saveEl: block.querySelector('.cpt-bundle-save-chip')
    };

    items.forEach(function (item) {
      item._cptFreeBadge = item.querySelector('.cpt-item-free-badge');
    });

    return block._cptBundleRefs;
  }

  function ensureSelectedSlots(selectedWrap, totalSelect) {
    if (!selectedWrap) return [];

    while (selectedWrap.children.length < totalSelect) {
      var slot = document.createElement('span');
      slot.className = 'cpt-selected-item cpt-selected-item--empty';
      selectedWrap.appendChild(slot);
    }

    while (selectedWrap.children.length > totalSelect) {
      selectedWrap.removeChild(selectedWrap.lastElementChild);
    }

    return Array.prototype.slice.call(selectedWrap.children);
  }

  /* ----------------------------------------------------------
     Tab Switching
     ---------------------------------------------------------- */
  function initTabs() {
    document.querySelectorAll('.cpt-section').forEach(function (section) {
      if (section.dataset.cptTabsBound === 'true') return;
      section.dataset.cptTabsBound = 'true';

      var tabBtns = Array.prototype.slice.call(section.querySelectorAll('.cpt-tab-btn'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.cpt-panel'));
      if (!tabBtns.length || !panels.length) return;

      function activateTab(tabId, options) {
        options = options || {};
        if (!tabId) return false;

        var selectedBtn = null;
        var targetPanel = null;

        tabBtns.forEach(function (b) {
          var isTarget = b.dataset.tabId === String(tabId);
          b.classList.toggle('is-active', isTarget);
          b.setAttribute('aria-selected', isTarget ? 'true' : 'false');
          if (isTarget) selectedBtn = b;
        });
        if (!selectedBtn) return false;

        panels.forEach(function (p) {
          var isTarget = p.dataset.tabId === String(tabId);
          p.classList.toggle('is-active', isTarget);
          if (isTarget) targetPanel = p;
        });

        if (targetPanel) {
          targetPanel.scrollTop = 0;
          if (options.scroll !== false) {
            var sectionTop = section.getBoundingClientRect().top + window.scrollY;
            if (window.scrollY > sectionTop) {
              window.scrollTo({ top: sectionTop, behavior: 'auto' });
            }
          }
        }

        return true;
      }

      section._cptActivateTab = activateTab;

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activateTab(btn.dataset.tabId, { scroll: true });
        });
      });

      var defaultBtn = section.querySelector('.cpt-tab-btn.is-active') || tabBtns[0];
      if (defaultBtn) activateTab(defaultBtn.dataset.tabId, { scroll: false });
    });

    if (window.Shopify && window.Shopify.designMode && !window.__cptEditorEventsBound) {
      window.__cptEditorEventsBound = true;

      document.addEventListener('shopify:block:select', function (event) {
        var selectedBlock = event.target;
        if (!selectedBlock || !selectedBlock.closest) return;
        var panel = selectedBlock.closest('.cpt-panel');
        if (!panel) return;
        var section = panel.closest('.cpt-section');
        if (!section || typeof section._cptActivateTab !== 'function') return;
        section._cptActivateTab(panel.dataset.tabId, { scroll: false });
      });

      document.addEventListener('shopify:section:load', function () {
        initTabs();
      });
    }
  }
  /* ----------------------------------------------------------
     1-Unit: Variant Chip Selection
     ---------------------------------------------------------- */
  function initChips() {
    document.querySelectorAll('.cpt-chips').forEach(function (chipGroup) {
      if (chipGroup.dataset.cptChipsBound === 'true') return;
      chipGroup.dataset.cptChipsBound = 'true';
      chipGroup.addEventListener('click', function (event) {
        var chip = event.target.closest('.cpt-chip');
        if (!chip || !chipGroup.contains(chip)) return;
        if (chip.classList.contains('is-unavailable')) return;

        chipGroup.querySelectorAll('.cpt-chip').forEach(function (c) { c.classList.remove('is-selected'); });
        chip.classList.add('is-selected');

        var card = chip.closest('.cpt-promo-card');
        if (card) updateCardVariant(card, chip);
      });
    });
  }

  function updateCardVariant(card, chip) {
    var variantId = chip.dataset.variantId;
    var priceRaw = parseInt(chip.dataset.price || 0, 10);        /* in cents */
    var comparePriceRaw = parseInt(chip.dataset.comparePrice || 0, 10);
    var imageSrc = chip.dataset.image;
    var productTitle = chip.dataset.productTitle;
    var variantTitle = chip.dataset.variantTitle;
    var discountType = card.dataset.discountType;
    var discountValue = parseFloat(card.dataset.discountValue || 0);
    var promoMode = card.dataset.promoMode;

    /* Update image */
    if (imageSrc) {
      var img = card.querySelector('.cpt-product-image img');
      if (img) img.src = imageSrc;
    }

    var pTitle = card.querySelector('.cpt-product-name');
    if (pTitle && productTitle) pTitle.textContent = productTitle;

    /* Update variant label */
    var vLabel = card.querySelector('.cpt-variant-label');
    if (vLabel) {
      var cleanVariantTitle = (variantTitle || '').trim();
      if (cleanVariantTitle.toLowerCase() === 'default title') cleanVariantTitle = '';
      vLabel.textContent = cleanVariantTitle ? ('- ' + cleanVariantTitle) : '';
    }

    /* Calculate promo price */
    var originalCents = priceRaw;
    var promoCents = originalCents;

    if (promoMode === 'bundle_2') {
      if (discountType === 'percent') {
        promoCents = Math.round((originalCents * 2) * (1 - discountValue / 100));
      } else if (discountType === 'bundle_price') {
        promoCents = Math.round(discountValue * 100);
      }
    } else {
      if (discountType === 'percent') {
        promoCents = Math.round(originalCents * (1 - discountValue / 100));
      } else if (discountType === 'fixed') {
        promoCents = Math.round(originalCents - (discountValue * 100));
      }
    }

    promoCents = Math.max(0, promoCents);
    var savedCents = promoMode === 'bundle_2' ? ((originalCents * 2) - promoCents) : (originalCents - promoCents);

    /* Update DOM */
    var priceNew = card.querySelector('.cpt-price-new');
    var priceOld = card.querySelector('.cpt-price-old');
    var savings = card.querySelector('.cpt-savings');
    var chipIsUnavailable = chip.classList.contains('is-unavailable') || chip.disabled;

    if (priceNew) priceNew.textContent = formatMoney(promoCents);
    if (priceOld && originalCents !== promoCents) {
      priceOld.textContent = formatMoney(comparePriceRaw || originalCents);
      priceOld.style.display = '';
    } else if (priceOld) {
      priceOld.textContent = '';
      priceOld.style.display = 'none';
    }
    if (savings && savedCents > 0) {
      savings.textContent = t('save_amount', { amount: formatMoney(savedCents) });
      savings.style.display = '';
    } else if (savings) {
      savings.textContent = '';
      savings.style.display = 'none';
    }

    /* Update ATC button */
    var atcBtn = card.querySelector('.cpt-btn-atc');
    if (atcBtn) {
      var defaultLabel = promoMode === 'bundle_2' ? t('add_bundle') : t('add_to_cart');
      atcBtn.dataset.variantId = variantId;
      atcBtn.dataset.originalText = chipIsUnavailable ? t('sold_out') : defaultLabel;
      atcBtn.textContent = chipIsUnavailable ? t('sold_out') : defaultLabel;
      atcBtn.disabled = chipIsUnavailable;
    }
  }

  /* ----------------------------------------------------------
     2-unit & 4-unit: Bundle / Mix-Match / BXGY Selection
     ---------------------------------------------------------- */
  function initBundleSelectors() {
    document.querySelectorAll('.cpt-bundle-block').forEach(function (block) {
      if (block.dataset.cptBundleBound === 'true') return;
      block.dataset.cptBundleBound = 'true';
      var isSupportedSlot = !!block.closest('.cpt-block--2, .cpt-block--4');
      if (!isSupportedSlot) return;
      var promoMode = block.dataset.promoMode;   /* mix_match | bxgy */
      var discountType = normalizeDiscountType(block.dataset.discountType);
      var discountValue = parseFloat(block.dataset.discountValue || 0);
      var buyQty = parseInt(block.dataset.buyQty || 1, 10);
      var getQty = parseInt(block.dataset.getQty || 0, 10);
      var totalSelect = buyQty + getQty;
      block.classList.toggle('cpt-bundle-block--stacked-summary', buyQty > 2);
      var atcBtn = block.querySelector('.cpt-btn-atc');
      var items = block.querySelectorAll('.cpt-product-grid-item');
      var availableCount = 0;
      block._cptSelections = [];

      items.forEach(function (item) {
        var isUnavailable = item.classList.contains('is-unavailable') || item.dataset.available === 'false';
        item.setAttribute('tabindex', isUnavailable ? '-1' : '0');
        if (!isUnavailable) availableCount++;
      });
      block._cptAvailableCount = availableCount;

      function activateBundleItem(item) {
        if (!item || item.classList.contains('is-unavailable') || item.dataset.available === 'false') return;
        var selections = block._cptSelections || [];
        if (selections.length >= totalSelect) selections.shift();
        selections.push({
          variantId: item.dataset.variantId,
          price: parseInt(item.dataset.price || 0, 10),
          image: item.dataset.image || ((item.querySelector('img') && (item.querySelector('img').currentSrc || item.querySelector('img').getAttribute('src'))) || '')
        });
        block._cptSelections = selections;

        renderBundleSelections(block, selections, buyQty, promoMode);
        updateBundleSummary(block, selections, buyQty, totalSelect, promoMode, discountType, discountValue);
        setBundleATCState(block, atcBtn, buyQty);
      }

      block.addEventListener('click', function (event) {
        var clearBtn = event.target.closest('.cpt-clear-btn');
        if (clearBtn && block.contains(clearBtn)) {
          block._cptSelections = [];
          renderBundleSelections(block, [], buyQty, promoMode);
          updateBundleSummary(block, [], buyQty, totalSelect, promoMode, discountType, discountValue);
          setBundleATCState(block, atcBtn, buyQty);
          return;
        }

        var item = event.target.closest('.cpt-product-grid-item');
        if (!item || !block.contains(item)) return;
        activateBundleItem(item);
      });

      block.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var item = event.target.closest('.cpt-product-grid-item');
        if (!item || !block.contains(item)) return;
        event.preventDefault();
        activateBundleItem(item);
      });

      renderBundleSelections(block, [], buyQty, promoMode);
      updateBundleSummary(block, [], buyQty, totalSelect, promoMode, discountType, discountValue);
      setBundleATCState(block, atcBtn, buyQty);
    });
  }


  function setBundleATCState(block, atcBtn, buyQty) {
    if (!atcBtn) return;
    var availableCount = block._cptAvailableCount != null
      ? block._cptAvailableCount
      : block.querySelectorAll('.cpt-product-grid-item:not(.is-unavailable)').length;
    var allowDuplicates = block.dataset.allowDuplicates !== 'false';
    var addLabel = block.dataset.addLabel || t('add_bundle');
    var soldOutLabel = block.dataset.soldOutLabel || t('sold_out');
    var selections = block._cptSelections || [];
    var promoMode = block.dataset.promoMode;
    var getQty = parseInt(block.dataset.getQty || 0, 10);
    var requiredQty = promoMode === 'bxgy' ? (buyQty + getQty) : buyQty;

    if (availableCount === 0 || (!allowDuplicates && availableCount < buyQty)) {
      atcBtn.disabled = true;
      atcBtn.textContent = soldOutLabel;
      return;
    }

    atcBtn.textContent = addLabel;
    atcBtn.disabled = selections.length < requiredQty;
  }

  function renderBundleSelections(block, selections, buyQty, promoMode) {
    var refs = getBundleRefs(block);
    var getQty = parseInt(block.dataset.getQty || 0, 10);
    var totalSelect = buyQty + getQty;
    var qtyById = {};
    var freeById = {};
    selections.forEach(function (sel, idx) {
      qtyById[sel.variantId] = (qtyById[sel.variantId] || 0) + 1;
      if (promoMode === 'bxgy' && idx >= buyQty) {
        freeById[sel.variantId] = (freeById[sel.variantId] || 0) + 1;
      }
    });

    refs.items.forEach(function (el) {
      var vid = el.dataset.variantId;
      var qty = qtyById[vid] || 0;
      var freeQty = freeById[vid] || 0;
      var freeBadge = el._cptFreeBadge;
      el.classList.toggle('is-selected', qty > 0);
      el.classList.toggle('is-free', freeQty > 0);
      el.setAttribute('aria-checked', qty > 0 ? 'true' : 'false');
      el.setAttribute('data-selected-qty', qty);
      if (freeBadge) freeBadge.style.display = freeQty > 0 ? '' : 'none';
    });

    if (refs.selectedWrap) {
      var slotEls = ensureSelectedSlots(refs.selectedWrap, Math.max(totalSelect, 1));
      slotEls.forEach(function (slot, i) {
        var sel = selections[i];
        var isFree = promoMode === 'bxgy' && i >= buyQty;
        slot.className = 'cpt-selected-item';
        slot.textContent = '';

        if (!sel) {
          slot.classList.add('cpt-selected-item--empty');
          return;
        }

        if (isFree) slot.classList.add('cpt-selected-item--free');

        if (sel.image) {
          var img = document.createElement('img');
          img.src = sel.image;
          img.alt = '';
          img.decoding = 'async';
          img.width = 40;
          img.height = 40;
          slot.appendChild(img);
        }

        if (isFree) {
          var indicator = document.createElement('span');
          indicator.className = 'cpt-selected-free-indicator';
          indicator.setAttribute('aria-hidden', 'true');
          slot.appendChild(indicator);
        }
      });
    }

    block.classList.toggle('has-selection', selections.length > 0);
  }

  function updateBundleSummary(block, selections, buyQty, totalSelect, promoMode, discountType, discountValue) {
    var refs = getBundleRefs(block);
    var summaryText = refs.summaryText;
    var pricingWrap = refs.pricingWrap;
    var oldEl = refs.oldEl;
    var newEl = refs.newEl;
    var saveEl = refs.saveEl;
    if (!summaryText) return;

    var selCount = selections.length;
    var remaining = buyQty - selCount;
    updateBundleCount(block, selCount, buyQty, totalSelect - buyQty, promoMode);

    if (remaining > 0) {
      summaryText.textContent = t('select_more', { n: remaining });
    } else if (promoMode === 'bxgy' && selCount < totalSelect) {
      summaryText.textContent = t('select_free', { n: totalSelect - selCount });
    } else {
      summaryText.textContent = t('ready_to_add');
    }

    if (!pricingWrap) return;
    if (selCount < buyQty) {
      pricingWrap.style.display = 'none';
      return;
    }

    var basePaid = 0;
    for (var i = 0; i < buyQty; i++) basePaid += (selections[i] ? selections[i].price : 0);
    var charge = basePaid;
    if (promoMode === 'mix_match') {
      if (discountType === 'fixed_price') {
        charge = Math.round(discountValue * 100);
      } else if (discountType === 'fixed_amount') {
        charge = Math.round(basePaid - (discountValue * 100));
      } else if (discountType === 'percent') {
        charge = Math.round(basePaid * (1 - (discountValue / 100)));
      }
    }
    if (promoMode === 'bxgy') {
      charge = basePaid;
    }
    charge = Math.max(0, charge);
    var saved = Math.max(0, basePaid - charge);

    if (oldEl) {
      oldEl.textContent = formatMoney(basePaid);
      oldEl.style.display = saved > 0 ? '' : 'none';
    }
    if (newEl) newEl.textContent = formatMoney(charge);
    if (saveEl) {
      saveEl.textContent = t('save_amount', { amount: formatMoney(saved) });
      saveEl.style.display = saved > 0 ? '' : 'none';
    }
    pricingWrap.style.display = '';
  }

  function updateBundleCount(block, selectedCount, buyQty, getQty, promoMode) {
    var countText = block.querySelector('.cpt-bundle-count-text');
    if (!countText) return;

    var paidCount = Math.min(selectedCount, buyQty);
    if (promoMode === 'bxgy' && selectedCount >= buyQty) {
      var freeCount = Math.max(0, selectedCount - buyQty);
      countText.textContent = t('paid_free_count', { paid: paidCount, free: freeCount });
      return;
    }

    countText.textContent = t('selected_count', { selected: paidCount, total: buyQty });
  }

  /* ----------------------------------------------------------
     AJAX Add to Cart
     ---------------------------------------------------------- */
  function initATC() {
    if (document.documentElement.dataset.cptAtcBound === 'true') return;
    document.documentElement.dataset.cptAtcBound = 'true';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cpt-btn-atc');
      if (!btn) return;
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      e.preventDefault();

      var bundleBlock = btn.closest('.cpt-bundle-block');
      if (bundleBlock) {
        addBundleToCart(btn, bundleBlock);
      } else {
        addSingleToCart(btn);
      }
    });
  }

  function addSingleToCart(btn) {
    var card = btn.closest('.cpt-promo-card');
    var variantId = btn.dataset.variantId;
    var quantity = parseInt(btn.dataset.quantity || 1, 10);

    if (!variantId) { showError(btn, t('no_variant_selected')); return; }

    setLoading(btn, true);

    cartAdd({ id: variantId, quantity: quantity }, function (err) {
      setLoading(btn, false);
      if (err) { showError(btn, err); }
      else {
        flashAdded(btn);
        refreshCartCount();
      }
    });
  }

  function addBundleToCart(btn, block) {
    var selected = block._cptSelections || [];
    var qtyById = {};
    selected.forEach(function (sel) {
      qtyById[sel.variantId] = (qtyById[sel.variantId] || 0) + 1;
    });
    var items = Object.keys(qtyById).map(function (id) {
      return { id: id, quantity: qtyById[id] };
    });

    if (items.length === 0) return;

    setLoading(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setLoading(btn, false);
        if (data.status) {
          showError(btn, data.description || t('cart_error'));
        } else {
          flashAdded(btn);
          refreshCartCount();
          /* Reset selections */
          block.querySelectorAll('.cpt-product-grid-item').forEach(function (el) {
            el.classList.remove('is-selected', 'is-free');
            el.setAttribute('data-selected-qty', '0');
            var freeBadge = el.querySelector('.cpt-item-free-badge');
            if (freeBadge) freeBadge.style.display = 'none';
          });
          var selectedWrap = block.querySelector('.cpt-selected-items');
          if (selectedWrap) selectedWrap.innerHTML = '';
          var pricingWrap = block.querySelector('.cpt-bundle-pricing');
          if (pricingWrap) pricingWrap.style.display = 'none';
          var summaryText = block.querySelector('.cpt-bundle-summary-text');
          var buyQty = parseInt(block.dataset.buyQty || 1, 10);
          if (summaryText) summaryText.textContent = t('select_more', { n: buyQty });
          block._cptSelections = [];
          renderBundleSelections(block, [], buyQty, block.dataset.promoMode);
          updateBundleCount(block, 0, buyQty, parseInt(block.dataset.getQty || 0, 10), block.dataset.promoMode);
          setBundleATCState(block, btn, buyQty);
        }
      })
      .catch(function () {
        setLoading(btn, false);
        showError(btn, t('network_error'));
      });
  }

  function cartAdd(payload, cb) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) cb(data.description || t('cart_error'));
        else cb(null, data);
      })
      .catch(function () { cb(t('network_error')); });
  }

  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var sectionUrl = root + '?sections=cart-icon-bubble';

    var cartReq = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; });

    var sectionReq = document.getElementById('cart-icon-bubble')
      ? fetch(sectionUrl, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.ok ? r.json() : null; })
      : Promise.resolve(null);

    Promise.all([cartReq, sectionReq])
      .then(function (results) {
        var cart = results[0];
        var payload = results[1];
        if (!cart) return;

        var count = cart.item_count || 0;
        var selectors = [
          '.cart-count-bubble span[aria-hidden]',
          '.cart-count-bubble span:not(.visually-hidden)',
          '[data-cart-count]',
          '.header__cart-count',
          'cart-notification-button .cart-count-bubble span',
          '#cart-icon-bubble .cart-count-bubble',
          '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]',
          '.cart-item-count'
        ];
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.textContent = count;
          });
        });

        if (payload && payload['cart-icon-bubble']) {
          var host = document.getElementById('cart-icon-bubble');
          if (host) {
            var tpl = document.createElement('template');
            tpl.innerHTML = payload['cart-icon-bubble'];
            var fresh = tpl.content.querySelector('#cart-icon-bubble') || tpl.content.firstElementChild;
            if (fresh) host.innerHTML = fresh.innerHTML;
          }
        }

        requestAnimationFrame(function () {
          var detail = { cart: cart };
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
          document.documentElement.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: detail }));
        });
      })
      .catch(function () { });
  }

  /* ----------------------------------------------------------
     UI Helpers
     ---------------------------------------------------------- */
  function setLoading(btn, state) {
    btn.classList.toggle('is-loading', state);
  }

  function flashAdded(btn) {
    var orig = btn.dataset.originalText || btn.textContent;
    btn.dataset.originalText = orig;
    btn.classList.add('is-added');
    btn.textContent = t('added_to_cart');
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = orig;
    }, 2200);
  }

  function showError(btn, msg) {
    var existing = btn.parentNode.querySelector('.cpt-error-msg');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'cpt-error-msg';
    el.textContent = msg;
    btn.insertAdjacentElement('afterend', el);
    setTimeout(function () { el.remove(); }, 4000);
  }

  /* ----------------------------------------------------------
     Boot
     ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    initTabs();
    initChips();
    initBundleSelectors();
    initATC();
  }

})();

